const accountCenterUrl = process.env.NEXT_PUBLIC_ACCOUNT_CENTER_URL;

export const NavbarMobileLoginButton = () => (
  <button
    type="button"
    className="navbar-mobile-login-button"
    onClick={() => window.location.assign(`${accountCenterUrl}/login`)}
  >
    Log In
  </button>
);
